import images from "../../../../../../../../../utilities/images/images";
import "./StorePerformanceBanner.scss";

export const StorePerformanceBanner = () => {
  return (
    <div className="performance-inner-wrapper">
      <div className="performance-benefits-list">
        <div className="performance-benefit-item">
          <img
            src={images?.learningPerformance}
            alt="learningPerformance"
            className="benefit-icon"
          />
          <span className="performance-benefit-name">
            Improve Your Overall Learning Performance
          </span>
        </div>
      </div>
    </div>
  );
};
